import { ExternalLink } from 'lucide-react';

export const BUILD_VERSION = 'v7.2.2';

export function profileInitial(user) {
  return String(user?.displayName || user?.username || 'S').trim().charAt(0).toUpperCase() || 'S';
}

export function MirrorWord({ className = '' }) {
  return (
    <span className={`mirror-word ${className}`.trim()} role="img" aria-label="MIRROR">
      <span aria-hidden="true">M</span>
      <span aria-hidden="true">I</span>
      <span aria-hidden="true" className="mirror-r">R</span>
      <span aria-hidden="true" className="mirror-r">R</span>
      <span aria-hidden="true">O</span>
      <span aria-hidden="true" className="mirror-r">R</span>
    </span>
  );
}

export function MirrorReflector({ className = '' }) {
  return <svg className={`mirror-reflector ${className}`.trim()} viewBox="0 0 64 64" role="img" aria-label="Mirror reflector">
    <ellipse cx="32" cy="32" rx="20" ry="27" fill="none" stroke="currentColor" strokeWidth="2" />
    <ellipse cx="32" cy="32" rx="13" ry="20" fill="none" stroke="currentColor" strokeWidth="1" opacity=".55" />
    <path d="M7 32h50M32 7v50" fill="none" stroke="currentColor" strokeWidth="1" opacity=".35" />
    <circle cx="32" cy="32" r="3" fill="currentColor" />
  </svg>;
}

export function BrandMark() {
  return <div className="brand"><MirrorWord /><MirrorReflector /></div>;
}

export function MirrorSplashLogo() {
  return (
    <div className="mirror-splash-logo" aria-label="MIЯЯOЯ">
      <svg className="mirror-splash-mark" viewBox="0 0 512 512" role="presentation" aria-hidden="true">
        <path className="mirror-splash-mark-frame" d="M104 344V166l152 74 152-74v178" fill="none" stroke="currentColor" strokeWidth="32" strokeLinecap="square" strokeLinejoin="miter" />
        <path className="mirror-splash-mark-spine" d="M256 240v142" fill="none" stroke="currentColor" strokeWidth="18" />
      </svg>
      <MirrorWord />
    </div>
  );
}

export function AiZerepCredit() {
  return (
    <footer className="atelier-credit">
      <a className="atelier-credit-owner" href="https://empiricalskye.com/" target="_blank" rel="noreferrer"><MirrorReflector /> © {new Date().getFullYear()} Empirical Skye Designs</a>
      <div className="atelier-credit-heading">
        <span>Built by</span>
        <a href="https://azerep.com/aizerep.html" target="_blank" rel="noreferrer">
          AiZerep <ExternalLink aria-hidden="true" />
        </a>
      </div>
      <small className="atelier-credit-version">Build {BUILD_VERSION}</small>
    </footer>
  );
}

export function MirrorFooter() {
  return <footer className="mirror-app-footer">
    <div className="mirror-footer-thesis">
      <strong>Augmented Perception</strong>
      <span>“If it can be observed, it can be reflected. If it can be reflected, it can be understood.”</span>
    </div>
    <div className="mirror-footer-identity">
      <BrandMark />
      <a href="https://empiricalskye.com/" target="_blank" rel="noreferrer">© {new Date().getFullYear()} Empirical Skye Designs</a>
    </div>
  </footer>;
}
